import * as React from "react"
import '../scss/footer.scss'
import { StaticImage } from "gatsby-plugin-image"
import FloatingButtons from "./floating_buttons"
import { Link } from "gatsby"

const Footer = () => {
  return <footer
    className="Footer__Container"
  >
    <div className="Footer__Upper primary-background-color">
      <div className="Footer__Content">
        <div className="Footer__Left">
          <div className="Footer__Logo">
            <StaticImage
              transformOptions={{
                fit: 'contain'
              }}
              placeholder="none"
              width={400}
              src="../images/logo_complete.png"
              alt="Narrativi Digitali"
              title="Narrativi Digitali"
            />
          </div>

          <div className="Footer__Info">
            Ci piace giocare sul serio.<br />
          </div>


          <div className="Footer__Sitemap">
            <div className="Footer__SitemapColumn">
              <Link to="/" className="Footer__SitemapLink">Home</Link>
              <Link to="/projects" className="Footer__SitemapLink">Progetti</Link>
              <Link to="/manifesto" className="Footer__SitemapLink">Manifesto</Link>
              <Link to="/contacts" className="Footer__SitemapLink">Contattaci</Link>
            </div>
            <div className="Footer__SitemapColumn">
              <Link to="/aziende" className="Footer__SitemapLink">Per le aziende</Link>
              <Link to="/scuole" className="Footer__SitemapLink">Per le scuole</Link>
              <Link to="/sociale" className="Footer__SitemapLink">Per il sociale</Link>
            </div>

          </div>


        </div>
        <div className="Footer__Right">
          <div style={{
            marginBottom: 20
          }}>
            Our projects are<br /> proudly made with
          </div>
          <a href="https://godotengine.org/" target="_blank">
            <StaticImage
              transformOptions={{
                fit: 'contain'
              }}
              placeholder="none"
              width={100}
              src="../images/godot_logo.png"
              alt="godot game engine"
            />
          </a>

        </div>
      </div>
    </div>
    <div className="Footer__Lower">
      <div className="Footer__Content">
        <div className="Footer__Left">
          <div className="Footer__Info">
            <a href="https://www.iubenda.com/privacy-policy/94435075" target="_blank">Privacy Policy</a> <a href="https://www.iubenda.com/privacy-policy/94435075/cookie-policy" target="_blank">Cookie Policy</a>
          </div>

        </div>
        <div className="Footer__Center">
          Narrativi Digitali Srls P.IVA 05122970238<br />
          Viale della Repubblica 10 37126 Verona
        </div>
        <div className="Footer__Right">
          <div className="Footer__Socials">
            <a href="https://www.linkedin.com/company/narratividigitali/" target="_blank">
              <StaticImage
                placeholder="none"
                width={30}
                src="../images/social/linkedin_icon.png"
                alt="linkedin"
                quality={100}
              />
            </a>
            <a href="https://www.instagram.com/narrativi_digitali/" target="_blank">
              <StaticImage
                placeholder="none"
                width={30}
                src="../images/social/instagram_icon.png"
                alt="instagram"
                quality={100}
              />
            </a>

          </div>
        </div>
      </div>
    </div>
    <FloatingButtons />

  </footer>
}

export default Footer